import JsBarcode from 'jsbarcode';
import moment from 'moment';
import 'moment/locale/tr';
import React from 'react';
import { Button } from 'reactstrap';
import { setPrintedColumnTrue } from '../api';

const Irsaliye = ({ data, text = "" }) => {
    const generateBarcode = (value) => {
        try {
            const canvas = document.createElement('canvas');
            JsBarcode(canvas, value, {
                format: 'CODE128',
                width: 2,
                height: 50,
                displayValue: true,
                fontSize: 14,
                margin: 10,
            });
            return canvas.toDataURL('image/png', 1.0);
        } catch (error) {
            console.error('Barkod oluşturma hatası:', error);
            return null;
        }
    };

    const groupVehicles = (chassis_details) => {
        const groups = {};

        chassis_details.forEach(vehicle => {
            const key = `${vehicle.brand}_${vehicle.target}`;
            if (!groups[key]) {
                groups[key] = {
                    brand: vehicle.brand,
                    target: vehicle.target,
                    vehicles: []
                };
            }
            groups[key].vehicles.push(vehicle);
        });

        return Object.values(groups);
    };

    const handlePrint = async () => {
        try {
            const iframe = document.createElement('iframe');
            document.body.appendChild(iframe);
            iframe.style.position = 'absolute';
            iframe.style.left = '-9999px';

            const vehicleGroups = groupVehicles(data.chassis_details);
            const barcode = generateBarcode(data.groupage_no);

            // Track if the API call has been made
            let apiCallMade = false;

            // Function to make the API call
            const makeApiCall = async () => {
                if (!apiCallMade) {
                    await setPrintedColumnTrue({
                        groupage_no: data.groupage_no
                    });
                    apiCallMade = true;
                }
            };

            const generateDeliveryNote = (group) => {
                return `
                <div class="irsaliye-container">
                    ${['ASIL', '1. SURET', '2. SURET'].map((type) => `
                        <div class="irsaliye">
                            <div class="content">
                                <div class="dates">
                                    <table class="dates-table">
                                        <tr>
                                            <td class="label">Düzenleme Tarihi</td>
                                            <td style="text-align:left;">${moment().format('DD.MM.YYYY HH:mm:ss')}</td>
                                        </tr>
                                        <tr>
                                            <td class="label">Planlanan Sevk Tarihi</td>
                                            <td style="text-align:left;">${moment(data.shipping_date).format('DD.MM.YYYY HH:mm:ss')}</td>
                                        </tr>
                                        <tr>
                                            <td class="label">Grupaj No</td>
                                            <td style="text-align:left;">${data.groupage_no || ""}</td>
                                        </tr>
                                      <tr>
                                            <td class="label">Grupaj Tarih</td>
                                            <td style="text-align:left;">${moment(data.create_date).format('DD.MM.YYYY')}</td>
                                        </tr>
                                        <tr>
                                            <td class="label">Matbu No</td>
                                            <td style="text-align:left;">${data.paper || ""}</td>
                                        </tr>
                                    </table>
                                </div>

                                <div class="barcode">
                                    <img src="${barcode}" />
                                </div>
                                
                                <div class="address-pair">
                                    <div class="address-left">
                                        ${group.vehicles[0].exit_warehouse_code || ""}<br/>
                                        ${group.vehicles[0].exit_warehouse || ""}<br/><br/>
                                        ${group.vehicles[0].exit_warehouse_address_description || ""}
                                    </div>
                                    <div class="address-right">
                                        ${group.target || ""}<br/>
                                        ${group.vehicles[0].address || ""}
                                    </div>
                                </div>

                                <div class="details-table">
                                    <table>
                                        <tr>
                                            <th></th>
                                            <th>Şase No</th>
                                            <th>Model</th>
                                            <th>Renk</th>
                                            <th>Nakliye</th>
                                        </tr>
                                        ${group.vehicles.map((vehicle, index) => `
                                            <tr>
                                                <td>${vehicle.chassis_no ? index + 1 : "0"}</td>
                                                <td>${vehicle.chassis_no}</td>
                                                <td>${vehicle.model || ""}</td>
                                                <td>${vehicle.color || ""}</td>
                                                <td>200 + KDV</td>
                                            </tr>
                                        `).join('')}
                                        ${Array(Math.max(0, 8 - group.vehicles.length))
                        .fill('<tr>' + Array(5).fill('<td>&nbsp;</td>').join('') + '</tr>')
                        .join('')}
                                    </table>
                                </div>

                                <div class="company-info">
                                    <div>${data.plate_number || ''} ${data.trailer_plate ? `/ ${data.trailer_plate}` : ''}</div>
                                    <div>${data.driver_name || ''}</div>
                                    ${data.truck_subcontractor_name || ''}<br/>
                                </div>
                            </div>
                        </div>
                    `).join('')}
                </div>
            `;
            };

            iframe.contentDocument.write(`
                <!DOCTYPE html>
                <html>
                    <head>
                        <title>İrsaliye-${data.groupage_no}</title>
                        <style>
                            @page { 
                                size: A4 landscape; 
                                margin: 0; 
                            }
                            body { 
                                margin: 0;
                                padding: 0;
                                font-family: Arial, sans-serif;
                                width: 297mm;
                                height: 210mm;
                            }
                            .irsaliye-container {
                                display: flex;
                                width: 297mm;
                                height: 210mm;
                            }
                            .irsaliye {
                                width: 99mm;
                                height: 210mm;
                                position: relative;
                                border-right: 1px dashed #ccc;
                            }
                            .irsaliye:last-child {
                                border-right: none;
                            }
                            .content {
                                padding: 20mm 5mm;
                                position: relative;
                            }
                            .dates {
                                position: absolute;
                                top: 35mm;
                                right: 5mm;
                                font-size: 11px;
                                line-height: 1.5;
                                text-align: right;
                            }
                            .dates .label {
                                display: inline-block;
                                width: 120px;
                                text-align: right;
                                margin-right: 5px;
                                white-space: nowrap;
                                font-size: 12px;
                            }
                            .barcode {
                                position: absolute;
                                top: 57mm;
                                right: 5mm;
                                text-align: right;
                            }
                            .barcode img {
                                max-width: 50mm;
                            }
                            .address-pair {
                                position: absolute;
                                top: 75mm;
                                left: 5mm;
                                right: 5mm;
                                display: flex;
                                justify-content: space-between;
                                font-size: 10px;
                                line-height: 1.4;
                            }
                            .address-left {
                                text-align: left;
                                width: 45%;
                            }
                            .address-right {
                                text-align: right;
                                width: 45%;
                            }
                            .company-info {
                                position: absolute;
                                top: 145mm;
                                left: 5mm;
                                font-size: 12px;
                                line-height: 1.4;
                                text-align: left;
                            }
                            .details-table {
                                position: absolute;
                                top: 105mm;
                                left: 5mm;
                                font-size: 10px;
                                width: 90mm;
                            }
                            .details-table table {
                                width: 100%;
                                border-collapse: collapse;
                                table-layout: auto;
                            }
                            .details-table th, .details-table td {
                                border: 1px solid gray;
                                padding: 0 2px;
                                text-align: left;
                                height: 3mm;
                                white-space: nowrap;
                                line-height: 1;
                            }
                            .details-table th {
                                font-weight: normal;
                            }
                            .details-table th:nth-child(1) {
                                width: min-content;
                            }
                            .details-table td:nth-child(1) {
                                text-align: center;
                            }
                            .details-table th:nth-child(3),
                            .details-table td:nth-child(3) {
                                white-space: normal;
                                font-size: 10px;
                                word-wrap: break-word;
                                word-break: break-word;
                                height: auto;
                                min-height: 3mm;
                                padding: 1px;
                            }
                        </style>
                    </head>
                    <body>
                        ${vehicleGroups.map((group) => generateDeliveryNote(group)).join('')}
                    </body>
                    <script>
                        
                        // Handle print event
                        window.onbeforeprint = async function() {
                            window.parent.postMessage('beforeprint', '*');
                        };

                        window.onafterprint = function() {
                            window.parent.postMessage('afterprint', '*');
                            document.body.parentNode.removeChild(document.body);
                        };

                        // Handle PDF save event (Ctrl+S or browser save)
                        window.onbeforeunload = function() {
                            window.parent.postMessage('save', '*');
                            return null;
                        };

                        window.onload = function() {
                            window.print();
                        }
                    </script>
                </html>
            `);

            // Listen for messages from iframe
            const messageHandler = async (event) => {
                if (event.data === 'beforeprint' || event.data === 'save') {
                    await makeApiCall();
                }
            };

            window.addEventListener('message', messageHandler);

            // Cleanup
            iframe.onload = () => {
                setTimeout(() => {
                    if (!apiCallMade) {
                        console.log('🧹 Cleaning up - removing event listener and iframe');
                        window.removeEventListener('message', messageHandler);
                        document.body.removeChild(iframe);
                    }
                }, 1000);
            };

            iframe.contentDocument.close();
        } catch (error) {
            console.error('❌ Error during printing:', error);
        }
    };

    return (
        <Button
            onClick={handlePrint}
            style={{
                background: "#1abeff",
                color: "white"
            }}
            className="flex flex-col items-center justify-center p-2 border border-gray-300 bg-gray-100 text-gray-700 hover:bg-gray-200 rounded cursor-pointer"
        >
            <i className="fa fa-print text-xl mb-1" /> &nbsp;
            {text ? <span className="text-sm">{text}</span> : <span className="text-sm">İrsaliye Yazdır</span>}
        </Button>
    );
};

export default Irsaliye;
